import React from 'react';

/** Structure to create context for both the Provider in App.tsx and consumer, such as `ModalNoticeUI` */
export const ModalCookieContext = React.createContext<{ hasConsented: boolean }>({ hasConsented: true });